// 오늘 날짜에서 지정된 연수를 빼서 YYYYMMDD 형태로 반환하는 함수
function getAdultBirthDate(minAge = 18) {
  const today = new Date();

  // 현재 날짜에서 minAge년을 뺀 날짜 생성
  const adultBirthDate = new Date(
    today.getFullYear() - minAge,
    today.getMonth(),
    today.getDate()
  );

  // YYYYMMDD 형태로 변환
  const year = adultBirthDate.getFullYear();
  const month = (adultBirthDate.getMonth() + 1).toString().padStart(2, "0");
  const day = adultBirthDate.getDate().toString().padStart(2, "0");

  return parseInt(`${year}${month}${day}`);
}

export { getAdultBirthDate };
export { transformKeys, type InputData, type OutputData } from "./keyTransform";
